module.exports = __webpack_public_path__ + "img/vip_logo.ae96a870.png";